import React from 'react';
import PropTypes from 'prop-types';
import CountPill from '../../../../shared/components/pill/CountPill';

const STATUS_ICON = {
  ok: 'bi-check-circle-fill text-success',
  error: 'bi-x-circle-fill text-danger',
  skipped: 'bi-slash-circle text-muted',
  running: 'bi-arrow-repeat text-primary',
};

// Renders purely from the ordered `steps` array and never switches on step.type — that is what
// makes a second retrieval pass or a rerank appear here automatically. The connecting line is
// drawn between rows so an eight-step multi-pass run still reads as one sequence.
export default function OperationList({ steps, selectedId, onSelect }) {
  if (!steps || steps.length === 0) {
    return (
      <p className="text-muted small mb-0">
        Run a test to see the operations the system performs.
      </p>
    );
  }

  return (
    <ol className="list-unstyled mb-0 d-flex flex-column gap-1">
      {steps.map((step, index) => (
        <li key={step.id}>
          <button
            type="button"
            className={`btn btn-sm w-100 text-start border rounded p-2 ${
              step.id === selectedId ? 'border-primary bg-primary-subtle' : 'border-light-subtle bg-white'
            }`}
            onClick={() => onSelect(step.id)}
            aria-current={step.id === selectedId ? 'true' : undefined}
          >
            <div className="d-flex align-items-center gap-2">
              <CountPill className="flex-shrink-0">{index + 1}</CountPill>
              <span className="small fw-semibold flex-grow-1 text-truncate">{step.label}</span>
              <i className={`bi ${STATUS_ICON[step.status] || 'bi-circle text-muted'} flex-shrink-0`} />
            </div>
            <div className="d-flex justify-content-between align-items-center gap-2 mt-1">
              <span className="text-muted small text-truncate">{step.summary}</span>
              {step.duration_ms != null && (
                <span className="text-muted small font-monospace flex-shrink-0">{step.duration_ms} ms</span>
              )}
            </div>
          </button>
        </li>
      ))}
    </ol>
  );
}

OperationList.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.object),
  selectedId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

OperationList.defaultProps = { steps: [], selectedId: null };
